import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-escolha-tipo-disparo',
  standalone: true,
  imports: [],
  templateUrl: './escolha-tipo-disparo.component.html',
  styleUrl: './escolha-tipo-disparo.component.css'
})
export class EscolhaTipoDisparoComponent implements OnInit {

  @Output() envioTipo = new EventEmitter<any>();

  @Input() tipoDisparoEscolhido = {
    Whatsapp: true,
    Email: false,
    sms: false
  }
  @Input() listaDisabled = {
    Whatsapp: false,
    Email: false,
    sms: false
  }

  ngOnInit() {
    const todosFalse = Object.values(this.tipoDisparoEscolhido).every(v => !v);
    if (todosFalse) {
      this.tipoDisparoEscolhido.Whatsapp = true;
      this.envioTipo.emit(this.tipoDisparoEscolhido);
    }
  }

  selecionarTipo(tipo: 'Whatsapp' | 'Email' | 'sms'): void {
    if (this.listaDisabled[tipo]) {
      return;
    }
    const selecao = {
      Whatsapp: tipo === 'Whatsapp',
      Email: tipo === 'Email',
      sms: tipo === 'sms'
    };
    this.envioTipo.emit(selecao);
  }
}
